import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    menuWrapper: {
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(5),
    },
    menu: {
      display: "flex",
      flexWrap: "nowrap",
      padding: theme.spacing(2),
      position: "relative",
      overflow: "hidden",
    },
    menuTabsWrapper: {
      display: "flex",
      flexWrap: "nowrap",
      gap: theme.spacing(2),
      backgroundColor: theme.gray50,
      border: `1px solid ${theme.gray100}`,
      borderRadius: "6px",
      overflowX: "auto",
      "&::-ms-overflow-style": "none",
      scrollbarWidth: "none",
      "&::-webkit-scrollbar": { display: "none" },
      paddingRight: theme.spacing(0.5),
    },
    btn: {
      textWrap: "nowrap",
      minWidth: "90px",
      boxShadow: "none !important",
      flexShrink: 0,
      backgroundColor: theme.gray50,
      color: "#232529",
      padding: theme.spacing(3, 5),
      fontSize: "14px",
      lineHeight: "20px",

      "&.MuiButton-contained": {
        backgroundColor: theme.white00,
      },
    },
    arrowSlider: {
      width: "34px",
      height: "36px",
      position: "absolute",
      transform: "translateY(-50%)",
      zIndex: 2,
      top: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },
    iconWrapper: {
      width: "24px",
      height: "36px",
      backgroundColor: theme.gray50,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "6px",

      "& svg": {
        color: "#232529",
        width: "18px",
        height: "18px",
      },
    },
    contextMenu: {
      marginLeft: theme.spacing(2),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      "&:hover": {
        background: (props?: { isSelected: boolean }) =>
          props?.isSelected ? "#2F2657" : theme.primary50,
        borderRadius: "4px",
        color: (props?: { isSelected: boolean }) =>
          props?.isSelected ? theme.white00 : theme.primary500,
      },
    },
    tabMenu: {
      width: "277px",
    },
    tabMenuItem: { display: "flex", justifyContent: "space-between" },
    button: {
      color: theme.gray800,
      fontSize: 14,
      minWidth: "auto",
      "& >span": {
        marginRight: theme.spacing(2),
      },
      "& svg": {
        fontSize: "16px !important",
      },
    },
    menuContainer: {
      backgroundColor: theme.gray50,
      borderRadius: "6px",
      border: `1px solid ${theme.gray200}`,
      paddingRight: theme.spacing(5),
      overflow: "hidden",
    },
  }),
);
